<template>

<div>
    
    <div class='row mt-4' v-if='!isReady'>
        <div class='col-12 text-center'>
            <img src='/resources/loader.svg' width="75px">
        </div>
    </div>

    <div class="row mt-4" v-if='isReady'>
        <div class="col-12 d-flex flex-wrap justify-content-center justify-content-sm-start">
            <div v-for='i in images' :class="['img-thumb-fluid premium-content']">

                <span class="premium-tooltip">
                    <h6 class="mb-1">Premium content</h6>
                    <p class="mb-1">Want to see everything?</p>
                    <a :href='planURL()' target="_blank">Get a plan now</a>
                </span>

                <span class="img-thumb">                            
                    <span class="img-premium-icon">
                        <span class="icon icon-lock"></span>
                    </span>
                    <img :src="i.url_thumb" alt="Premium Content" class="img-fluid">
                </span>

            </div>

        </div>
    </div>
</div>
</template>

<script>
    export default {

        mounted() {

            this.getData();

        },

        props : ['m'],

        created() {
           
        },

        data() {
            return {

                isReady : false,

                images : [],

            }
        },

        methods : {

            getData() {

                this.ajax.call('mdl:pg', { m : this.m }, (r) => {

                    if( r.status == 'success' ) {
                        
                        this.images = r.data;
                        this.isReady = true;

                    }

                })
            }

        }  

    }
</script>
